import SignUpReducer from "./signUpReducer";
import companyListingReducer from "./companyListingReducer";
import companyDetailsReducer from "./companyDetailsReducer";
import executiveListingReducer from "./executiveListingReducer";
import executiveDetailsReducer from "./executiveDetailsReducer";
import HeaderReducer from "./headerReducer";
import leadListingReducer from "./leadListingReducer";
import LeadDetailsReducer from "./leadDetailsReducer";
import CommonReducer from "./commonReducer";
import DashboardReducer from "./dashboardReducer";
import WebToLeadReducer from "./webToLeadReducer";
import { combineReducers } from "redux";
import emailSetupReducer from "./emailSetupReducer";
import socialAuthReducer from "./socialAuthReducer"
import ReputationMangerReducer from "./reputationManagerReducer";
import UserManagementReducer from "./userManagementReducer";
import roleManagementReducer from "./roleManagementReducer";
import teamManagementReducer from "./teamManagerReducer";

const rootReducer = combineReducers({
  CommonReducer,
  HeaderReducer,
  SignUpReducer,
  companyListingReducer,
  companyDetailsReducer,
  executiveListingReducer,
  executiveDetailsReducer,
  leadListingReducer,
  LeadDetailsReducer,
  DashboardReducer,
  WebToLeadReducer,
  emailSetupReducer,
  socialAuthReducer,
  ReputationMangerReducer,
  UserManagementReducer,
  roleManagementReducer,
  teamManagementReducer,
});

export default rootReducer;
